import { BNS } from './BNS.model';

export class BAC extends BNS {

}
